import {
  WidgetKind,
  type Dimension,
  type Report,
  type WidgetOf,
} from 'corso-admin-ui';

const registeredBy = <const D extends Dimension<'registrations'>>(
  title: string,
  dimension: D,
) =>
  ({
    kind: WidgetKind.table,
    title,
    dimensions: [dimension],
    metrics: ['registeredProducts', 'orderClaims'],
    limit: 100,
  }) as const satisfies WidgetOf<'registrations'>;

export const products = {
  key: 'products',
  label: 'Products',
  dataset: 'registrations',
  timeFields: ['createdOn', 'purchasedOn'],
  widgets: [
    registeredBy('Products', 'productTitle'),
    registeredBy('Variants', 'variantDisplayName'),
  ],
} as const satisfies Report;
